import { field, date, children, writer, relation,text } from '@nozbe/watermelondb/decorators';
import { Model } from '@nozbe/watermelondb';
import { POS_TXNS_SCHEMA } from '../schema';

export default class PosTxns extends Model {
    static table = POS_TXNS_SCHEMA;

    static associations = {
        customer: { type: 'belongs_to', key: 'customer_id' },
        business: { type: 'belongs_to', key: 'business_id' },
        payment: { type: 'has_many', foreignKey: 'txns_id' },
        orders: { type: 'has_many', foreignKey: 'txns_id' }
    }

    @text('payment_method') payment_method;
    @text('discount_unit') discount_unit;
    @field('change_amount') change_amount;
    @field('discount') discount;
    @text('tax_type') tax_type;
    @field('amount') amount;
    @text('status') status;
    @field('trnsId') trnsId;
    @text('note') note;
    @text('type') type;
    @field('tax') tax;


    @date('created_at') created_at;

    @relation('customer', 'customer_id') customer;
    @relation('business', 'business_id') business;

    @children('payment') payment;
    @children('orders') orders;

    @writer async markAsDeleted() {
        await super.markAsDeleted();
    }

}